import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faHome,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import "./UserNav.css"
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";



const UserNav = () => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const params = useParams();
  const username = params.id;

  useEffect(() => {
    function isBiz(biz) {
      return biz.username === username;
    }

    const initializeMenu = async () => {
      try {
        const response = await axios.get("/services");
        const data = response.data.find(isBiz);
        setTitle(data.title);
        setLoading(false)
      } catch (err) {
        console.log(err);
        setTitle('JT NAIL');
        alert.setAlert({
          message: "Menu could not load right now, check back soon!",
          type: "danger",
        });
        setLoading(false)
      }
    };
    
    if (username === "services") {
      setLoading(false)
    } else if (username) {
      initializeMenu()
    } else {
      setLoading(false)
    }
    
  }, [username]);

  if (loading) return null
  return (
    <div className="navbar-fixed">
      <nav>
        <div className="nav-wrapper">

            <NavLink to="/" className="left nav-link blk">
              <FontAwesomeIcon icon={faHome} size="lg" />
            </NavLink>
        

          {pathname === "/services" || pathname === "/" ? (
           <span className="brand-logo center blk">JT Nails</span>
          ) : (
            <span className="brand-logo center blk">{title}</span>
          )}


          {pathname === "/"  || pathname=== "/login" ? (
            <NavLink to="/login" className="right nav-link blk" >
              <FontAwesomeIcon icon={faUser} size="lg"/>
            </NavLink>
          ) :
           (
            null
          )}
        </div>
      </nav>
    </div>
  );
};

export default UserNav;
